import AdminNavBar from './AdminNavBar'
export default AdminNavBar



// WEBPACK FOOTER //
// ./src/components/AdminNavBar/index.js